import { supabase } from '../lib/supabase'

/**
 * Catálogo de prioridades (`Tickets.priority`).
 * @namespace priorityService
 */
const priorityService = {
  schemaName: 'Tickets',
  tableName: 'priority',

  /**
   * Lista las prioridades.
   * @returns {Promise<{success: boolean, data: Array|null, error: string|undefined}>}
   */
  async getAll() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
      if (error) throw error
      return { success: true, data: data || [] }
    } catch (error) {
      console.error('Error fetching priorities:', error)
      return { success: false, data: null, error: error.message }
    }
  },
}

export default priorityService
